export default "__VITE_ASSET__B79NIcnT__"